import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  Customer,
  CustomerDetails,
  CustomerForm,
  CustomerStatusFilter,
} from "../types";
import {
  emptyCustomerDetails,
  initialCustomerForm,
  initialState,
} from "./initialState";

export const sliceKey = "customersState";

const customersSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getCustomersList(state) {
      state.loading = true;
      state.error = null;
    },

    getCustomersListSuccess(state, action: PayloadAction<Customer[]>) {
      state.loading = false;
      state.list = action.payload;
      state.error = null;
    },

    getCustomersListError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    setCustomersStatusFilter(
      state,
      action: PayloadAction<CustomerStatusFilter>
    ) {
      state.statusFilter = action.payload;
    },

    getCustomerDetails(state, action: PayloadAction<string>) {
      state.detailLoading = true;
      state.error = null;
      state.selectedCustomerId = action.payload;
      state.customerDetails = {
        ...emptyCustomerDetails,
        customerId: Number(action.payload),
      };
    },

    getCustomerDetailsSuccess(state, action: PayloadAction<CustomerDetails>) {
      state.detailLoading = false;
      state.customerDetails = action.payload;
      state.error = null;
    },

    getCustomerDetailsError(state, action: PayloadAction<string>) {
      state.detailLoading = false;
      state.customerDetails = {
        ...emptyCustomerDetails,
        customerId: Number(state.selectedCustomerId),
      };
      state.error = action.payload;
    },

    setCustomerDetailsStatus(state, action: PayloadAction<string>) {
      if (!state.customerDetails) {
        return;
      }
      state.customerDetails.status = action.payload;
    },

    clearCustomerDetails(state) {
      state.selectedCustomerId = null;
      state.customerDetails = null;
      state.detailLoading = false;
    },

    openAddModal(state) {
      state.isAddModalOpen = true;
      state.error = null;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.saving = false;
      state.error = null;
      state.form = initialCustomerForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof CustomerForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value;
    },

    resetForm(state) {
      state.form = initialCustomerForm;
    },

    addCustomer(state) {
      state.saving = true;
      state.error = null;
    },

    addCustomerSuccess(state) {
      state.saving = false;
      state.isAddModalOpen = false;
      state.form = initialCustomerForm;
      state.error = null;
    },

    addCustomerError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const { actions: customersActions, reducer } = customersSlice;
